var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f0f;opacity:0;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "#f0f",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84,20H12a4,4,0,0,0-4,4V72a4,4,0,0,0,4,4H84a4,4,0,0,0,4-4V24A4,4,0,0,0,84,20Zm-4,8v1.11L48,47.39,16,29.11V28ZM16,68V38.32L46,55.47a4,4,0,0,0,4,0L80,38.32V68Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.6b9ba7e0864e02c1a4e444f2b8130ae2.svg";
export { ForwardRef as ReactComponent };